const getCoordsCenter = (coords) => {
  if (coords.length === 0) {
    return null;
  }

  let sumX = 0;
  let sumY = 0;

  for (let i = 0; i < coords.length; i++) {
    sumX += coords[i][0]; // Soma as coordemadas x
    sumY += coords[i][1]; // Soma as coordemadas y
  }

  const centroX = sumX / coords.length;
  const centroY = sumY / coords.length;

  return [centroX, centroY];
}

export default getCoordsCenter;